// extracted by mini-css-extract-plugin
module.exports = {"cat-value-section":"cat-value_cat-value-section___M6hj"};